export interface PhoneStepSplit {
  startFields: any[];
  phoneField: any;
}

export interface PhoneSecondStepEligibilityInput {
  isStartPage: boolean;
  isNewPhoneField: boolean;
  startFields: any[];
  phoneField: any;
  hasMiddlePage: boolean;
  enableCustomStep: boolean;
  isFixedStepTemplate: boolean;
  canCreateSecondStep: boolean;
  hasCompleteStepStructure: boolean;
}

export type PhoneSecondStepIneligibleReason =
  | 'not_start_page'
  | 'not_new_phone_field'
  | 'phone_already_exists'
  | 'missing_non_phone_field'
  | 'middle_page_exists'
  | 'custom_step_disabled'
  | 'fixed_step_template'
  | 'step_limit_reached'
  | 'incomplete_step_structure';

export interface PhoneSecondStepEligibility {
  eligible: boolean;
  reason?: PhoneSecondStepIneligibleReason;
}

/**
 * 手机号拆分到第二步的统一资格校验。
 * 展示诊断建议与点击“一键采用”必须共用本方法，避免从事件入口绕过步骤限制。
 */
export function evaluatePhoneSecondStepEligibility(
  input: PhoneSecondStepEligibilityInput
): PhoneSecondStepEligibility {
  if (!input.isStartPage) return { eligible: false, reason: 'not_start_page' };
  if (!input.isNewPhoneField || input.phoneField?.type !== 'Mobile Number') {
    return { eligible: false, reason: 'not_new_phone_field' };
  }
  if (!Array.isArray(input.startFields)) {
    return { eligible: false, reason: 'incomplete_step_structure' };
  }
  if (input.startFields.some(field => field?.type === 'Mobile Number')) {
    return { eligible: false, reason: 'phone_already_exists' };
  }
  if (input.startFields.length === 0) {
    return { eligible: false, reason: 'missing_non_phone_field' };
  }
  if (input.hasMiddlePage) return { eligible: false, reason: 'middle_page_exists' };
  if (!input.enableCustomStep) return { eligible: false, reason: 'custom_step_disabled' };
  if (input.isFixedStepTemplate) return { eligible: false, reason: 'fixed_step_template' };
  if (!input.canCreateSecondStep) return { eligible: false, reason: 'step_limit_reached' };
  if (!input.hasCompleteStepStructure) {
    return { eligible: false, reason: 'incomplete_step_structure' };
  }
  return { eligible: true };
}

/** 仅生成字段重排计划，不修改传入配置。 */
export function planPhoneSecondStep(startFields: any[]): PhoneStepSplit | null {
  if (!Array.isArray(startFields) || startFields.length < 2) return null;
  const phoneFields = startFields.filter(field => field?.type === 'Mobile Number');
  if (phoneFields.length !== 1) return null;
  return {
    startFields: startFields.filter(field => field !== phoneFields[0]),
    phoneField: phoneFields[0],
  };
}
